// Read-only JSON view of the payload an execution was invoked with, with a
// one-click copy of the raw text.

import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { Button, Flex, H4 } from '@decisiv/ui-components';
import Copy from '@decisiv/iconix/lib/components/Copy';
import { JsonEditor } from 'json-edit-react';

import { DeveloperCodeView } from '../../styles/DeveloperCodeView';
import { CODE_EDITOR_THEME } from '../../theme/jsonEditorTheme';

// A payload that does not parse is still worth showing — and worth copying,
// which is usually the point when something is malformed. Rendering it raw
// beats taking the whole modal down.
const parsePayload = (payload) => {
  try {
    return { data: JSON.parse(payload), parsed: true };
  } catch (e) {
    return { data: null, parsed: false };
  }
};

export default function InvocationPayload({ payload }) {
  const { data, parsed } = parsePayload(payload);

  return (
    <Flex marginTop={2} flexDirection="column">
      <H4>
        <Trans>Invocation Payload</Trans>
      </H4>
      <Flex id="payloadBox" marginTop={1}>
        <DeveloperCodeView id="codeBox">
          {parsed ? (
            <JsonEditor
              viewOnly
              rootName=""
              theme={CODE_EDITOR_THEME}
              data={data}
            />
          ) : (
            <pre>{payload}</pre>
          )}
        </DeveloperCodeView>
        <Button
          style={{ borderRadius: '4px' }}
          icon={Copy}
          text={t`Copy`}
          id="copyBtn"
          variant="inverted"
          onClick={() => navigator.clipboard.writeText(payload)}
          size="small"
        />
      </Flex>
    </Flex>
  );
}

InvocationPayload.propTypes = { payload: PropTypes.string.isRequired };
